import React, { useState, useEffect } from 'react';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import StickyNote from "./StickyNote";
import { API_BASE_URL } from '../context/AuthContext';

export default function TabellaOrari() {
  const [giorni, setGiorni] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSchedules = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/schedules.php`);
        const data = await response.json();
        
        if (Array.isArray(data)) {
          // Raggruppa gli orari per giorno
          const grouped = data.reduce((acc, current) => {
            if (!acc[current.day_of_week]) {
              acc[current.day_of_week] = [];
            }
            acc[current.day_of_week].push(current.time_slot);
            return acc;
          }, {});

          // Crea l'array nel formato che si aspetta lo StickyNote
          // Puoi personalizzare l'ordine dei giorni
          const daysOrder = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
          
          const formattedDays = Object.keys(grouped)
            .sort((a, b) => {
              // Ordina per giorno della settimana se presente in daysOrder, altrimenti alfabetico
              let indexA = daysOrder.indexOf(a);
              let indexB = daysOrder.indexOf(b);
              if(indexA === -1) indexA = 99;
              if(indexB === -1) indexB = 99;
              return indexA - indexB;
            })
            .map(day => ({
              title: day,
              content: grouped[day].join('\n')
            }));

          setGiorni(formattedDays);
        }
      } catch (error) {
        console.error("Errore fetch schedules:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSchedules();
  }, []);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      {loading ? (
        <CircularProgress />
      ) : giorni.length === 0 ? (
        <Typography variant="body1">Nessun orario presente al momento.</Typography>
      ) : (
        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{ maxWidth: '1200px' }}
        >
          {giorni.map((giorno) => (
            <Grid item key={giorno.title} xs={12} sm={12} md={6} lg={3}>
              <StickyNote title={giorno.title} content={giorno.content} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}